const { customEvent } = require("../modules/tracking/AnalyticsEvents");

$(function() {
	const ANIMATION_TIME_MS = 1000;
	const $triggers = $("[data-cf-trigger]");
	// const imageElement = document.getElementById("cf-image");
	const purseElement = document.querySelector("[data-cf-trigger].purse");
	let flips = 0;
	let isDisabled = false;

	function processResult(result) {
		$("[data-cf]").each((i, el) => {
			const $el = $(el);
			const data = $el.data().cf.replace(/\s/g, "").split(",");
			const ANIMATION_TIME = 250;

			if (result === "heads" && data.includes('tails')) {
				$el.hide(0);
			} else if (data.includes("default")) {
				$el.fadeIn(ANIMATION_TIME);
			} else if (data.includes(result) || data === result) {
				$el.fadeIn(ANIMATION_TIME);
			}
		});

		lockButtons(result === "heads");
	}

	function lockButtons(locked = true) {
		isDisabled = locked;
		$triggers.attr("disabled", locked);

		purseElement.removeEventListener("touchstart", handleTouchStart, false)
		purseElement.removeEventListener("touchmove", handleTouchMove, { passive: false });

		if (! locked) {
			purseElement.addEventListener("touchstart", handleTouchStart, false);
			purseElement.addEventListener("touchmove", handleTouchMove, { passive: false });
		}
	}

	function flipCoin() {
		if (isDisabled) return;

		lockButtons(true);

		customEvent({
			category: "EV Convince Me",
			label: "Coin Flip",
			action: "Flipped",
		});

		const result = Math.random() >= 0.5 ? "heads" : "tails";
		flips++;

		// Set the placeholder image to the result:
		// imageElement.setAttribute('src', `https://img.grid.ws/623/500/EV%20Image%20${result}`);

		purseElement.setAttribute(
			"style",
			`--flip-animation: flip-${result}; --flip-animation-container: ${result}-container; --flip-animation-duration: ${ANIMATION_TIME_MS}ms; --flip-animation-delay: 0; --flip-animation-iteration: 1;`
		);

		document.getAnimations().forEach((animation) => {
			animation.cancel();

			if (animation?.animationName && animation?.animationName.includes(result)) {
				animation.play();
			}
		});


		setTimeout(() => {
			processResult(result);
			customEvent({
				category: "EV Convince Me",
				label: "Coin Flip - Result",
				action: result,
			});

		}, ANIMATION_TIME_MS);
	}

	processResult("default");

	$triggers.each((i, el) => {
		$(el).on("click", flipCoin);
	});

	// Mobile swipe

	let xDown = null;
	let yDown = null;

	function getTouches(evt) {
		return (
			evt.touches || // browser API
			evt.originalEvent.touches // jQuery
		);
	}

	function handleTouchStart(evt) {
		const firstTouch = getTouches(evt)[0];
		xDown = firstTouch.clientX;
		yDown = firstTouch.clientY;
	}

	function handleTouchMove(evt) {
		if (!xDown || !yDown) {
			return;
		}

		const yUp = evt.touches[0].clientY;

		const yDiff = yDown - yUp;

		if (yDiff > 0) {
			/* up swipe */
			flipCoin();

			// Disable scrolling
			document.addEventListener("touchstart", function (event) {
				const startY = event.touches[0].clientY;

				document.addEventListener(
					"touchmove",
					function (event) {
						const moveY = event.touches[0].clientY;
						if (startY > moveY && isDisabled) {
							event.preventDefault();
						}
					},
					{ passive: false }
				);
			});
		}

		/* reset values */
		xDown = null;
		yDown = null;
	}
});



// WEBPACK FOOTER //
// ./resources/assets/js/electric-vehicle-convince-me/coin-flip.js